<ng-select
  class="custom"
  [ngClass]="customColumnClasses"
  [readonly]="isDisabled"
  [style.flex]="1"
  [items]="itemsList"
  bindLabel="name"
  bindValue="id"
  placeholder="All"
  [clearable]="currentValue !== ''"
  [(ngModel)]="currentValue"
  (change)="valueChanged($event)"
>
  <ng-template ng-label-tmp let-item="item">
    {{ item.name }}
  </ng-template>
  <ng-template ng-option-tmp let-item="item">
    <span [title]="item.name" tooltip="item.name">{{ item.name }}</span>
  </ng-template>
</ng-select>
